import React from "react";
import { Link } from "react-router-dom";
import { formatPrice, resolveImage, CATEGORY_LABELS } from "@/lib/format";
import { useCart } from "@/lib/cart";
import { toast } from "sonner";
import { ShoppingBag } from "lucide-react";

export default function ProductCard({ product, index = 0 }) {
  const { add } = useCart();
  return (
    <div className="group fade-up" style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }} data-testid={`product-card-${product.id}`}>
      <Link to={`/product/${product.id}`} className="block">
        <div className="product-media aspect-[4/5]">
          {product.image_url ? (
            <img src={resolveImage(product.image_url)} alt={product.title} loading="lazy" />
          ) : (
            <div className="h-full w-full ph-checker" />
          )}
        </div>
      </Link>

      <div className="mt-4 flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="text-[10px] uppercase tracking-[0.18em] text-gold">
            {CATEGORY_LABELS[product.category] || product.category}
          </div>
          <Link to={`/product/${product.id}`} className="block mt-1 text-sm font-medium text-plum-deep hover:underline">
            {product.title}
          </Link>
        </div>
        <div className="text-sm font-medium whitespace-nowrap text-plum-deep">
          {formatPrice(product.price, product.currency)}
        </div>
      </div>

      <div className="mt-3 flex items-center gap-2">
        <Link
          to={`/product/${product.id}`}
          className="pill-btn flex-1 h-11 inline-flex items-center justify-center rounded-full border border-plum/15 text-plum-deep hover:bg-plum hover:text-white text-sm"
          data-testid={`view-product-${product.id}`}
        >
          View product
        </Link>
        <button
          onClick={(e) => {
            e.preventDefault();
            add(product);
            toast.success("Added to cart", { description: product.title });
          }}
          className="pill-btn h-11 w-11 inline-flex items-center justify-center rounded-full bg-plum text-white hover:bg-plum-deep"
          aria-label="Add to cart"
          data-testid={`add-to-cart-${product.id}`}
        >
          <ShoppingBag className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
